import * as React from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import requests from '../../../requests'
import { PATH } from '../../../constants/PATH'

const ProductDetailsProxy = () => {
  const history = useHistory()
  useEffect(() => {
    const { search, pathname } = history.location
    const URLParams = new URLSearchParams(search)
    const productId = URLParams.get('productId')
    console.log(history)
    requests.mall.fetchProductV2(productId)
      .then(res => {
        console.log('res', res)
        const { id } = res
        history.replace(`${pathname}/${id}`)
      })
      .catch(() => {
        window.toast.info(`商品信息获取出错[${productId}]`)
        history.replace(PATH.MALL)
      })
  }, [])
  return <div></div>
}

export default ProductDetailsProxy